var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldingBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 12.9167H11.0833C11.5696 12.9167 12.0359 12.7235 12.3797 12.3797C12.7235 12.0359 12.9167 11.5696 12.9167 11.0833C12.9167 10.5971 12.7235 10.1308 12.3797 9.78697C12.0359 9.44315 11.5696 9.25 11.0833 9.25H8.33333C7.78333 9.25 7.325 9.43333 7.05 9.8L1.91667 14.75M5.58333 18.4167L7.05 17.1334C7.325 16.7667 7.78333 16.5834 8.33333 16.5834H12C13.0083 16.5834 13.925 16.2167 14.5667 15.4834L18.7833 11.45C19.1371 11.1157 19.3435 10.6546 19.3573 10.1681C19.371 9.68163 19.1909 9.20959 18.8567 8.85586C18.5224 8.50213 18.0613 8.29567 17.5748 8.28192C17.0883 8.26817 16.6162 8.44824 16.2625 8.78252L12.4125 12.3575M1 13.8333L6.5 19.3333M16.4916 7.41676C16.4916 8.88491 15.3015 10.0751 13.8333 10.0751C12.3652 10.0751 11.175 8.88491 11.175 7.41676C11.175 5.9486 12.3652 4.75842 13.8333 4.75842C15.3015 4.75842 16.4916 5.9486 16.4916 7.41676ZM7.41667 3.75C7.41667 5.26878 6.18545 6.5 4.66667 6.5C3.14788 6.5 1.91667 5.26878 1.91667 3.75C1.91667 2.23122 3.14788 1 4.66667 1C6.18545 1 7.41667 2.23122 7.41667 3.75Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldingBookIcon);
export default __webpack_public_path__ + "static/media/HoldingBookIcon.6b72c79aebef7100f2e5a1fd2f00518c.svg";
export { ForwardRef as ReactComponent };